import { h, Component } from 'preact';

export default class Header extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      title: props.title,
      backurl: props.backurl,
    }
  }
  
  componentDidMount() {}
  
  render() {
    return (
      <section class="header">
        <div class="header_menu">
          <div class="d-flex align-items-center">
            <a href={(this.state.backurl ? this.state.backurl : '/')} class="mx-2"><i class="demo-icon icon-angle-left"></i></a>
            <span class="ms-2">{this.state.title}</span>
          </div>
        </div>
      </section>
    );
  }
}
